(function () {
  function clampPercent(value) {
    var number = parseFloat(value);

    if (Number.isNaN(number)) {
      return 50;
    }

    return Math.min(100, Math.max(0, number));
  }

  function initThreeSplitBanner(container) {
    var root = container || document;
    var items = root.querySelectorAll('[data-three-split-item]');

    items.forEach(function (item) {
      var desktopX = clampPercent(item.getAttribute('data-desktop-button-x'));
      var desktopY = clampPercent(item.getAttribute('data-desktop-button-y'));
      var mobileX = clampPercent(item.getAttribute('data-mobile-button-x'));
      var mobileY = clampPercent(item.getAttribute('data-mobile-button-y'));

      item.style.setProperty('--desktop-button-x', desktopX + '%');
      item.style.setProperty('--desktop-button-y', desktopY + '%');
      item.style.setProperty('--mobile-button-x', mobileX + '%');
      item.style.setProperty('--mobile-button-y', mobileY + '%');
    });
  }

  window.ThreeSplitBanner = {
    init: initThreeSplitBanner
  };

  document.addEventListener('DOMContentLoaded', function () {
    initThreeSplitBanner(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initThreeSplitBanner(event.target);
  });
})();
